import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Container,
    Typography,
} from "@mui/material";
import { useStoreState } from "pullstate";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../stores/AppStore.js";
import { api } from "../../utils/apiFunctions";
import { slackLoginPopup } from "../../utils/slackAuth.js";
import getRedirectURI from "../../utils/getRedirectURI.js";

const SlackAuth = () => {
    const redirectURI = getRedirectURI();
    const clientId = process.env.REACT_APP_SLACK_CLIENT_ID;
    const userScope =
        "groups:read,users.profile:read,users.profile:write,channels:read,chat:write";
    const navigate = useNavigate();
    const { user } = useStoreState(AppStore);

    const handleSlackLogin = async () => {
        try {
            const code = await slackLoginPopup(clientId, redirectURI, userScope);
            // console.log("Slack Auth Code:", code);

            // Exchange auth code for an access token
            const response = await api.post("/slack/api/auth", { code, user, redirectURI });
            console.log("response, ", response);

            if (response.data) {
                AppStore.update((s) => {
                    s.slackUserData = response.data;
                });

                // console.log("Slack login successful:", response.data);
                navigate("/employee"); // Redirect after login
            }
        } catch (error) {
            console.error("Slack login failed:", error);
        }
    };

    return (
        <Container sx={{ textAlign: "center", p: 4 }}>
            <Card sx={{ maxWidth: 345, margin: "0 auto" }}>
                <CardMedia
                    sx={{
                        height: "100px",
                        width: "300px",
                        margin: "0 auto",
                    }}
                    image="https://i.pcmag.com/imagery/reviews/07td46ju7p6lLVb0QGwc5VF-6.fit_scale.size_1028x578.v1569479844.jpg"
                    title="Slack"
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        Slack profile access required. Enhances app experience. Data used
                        responsibly.
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: "center" }}>
                    <Button
                        sx={{
                            alignItems: "center",
                            color: "#000",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            display: "inline-flex",
                            fontFamily: "Lato, sans-serif",
                            fontSize: "14px",
                            fontWeight: "600",
                            height: "44px",
                            justifyContent: "center",
                            textDecoration: "none",
                            width: "204px",
                        }}
                        onClick={handleSlackLogin}
                    >
                        Connect Slack
                    </Button>
                </CardActions>
            </Card>
        </Container>
    );
};

export default SlackAuth;
